import { Pipe, PipeTransform } from '@angular/core';

import { Document } from 'app/providers/storage-api/document.service';

@Pipe({
  name: 'experienceCardMetaData',
  standalone: false,
})
export class ExperienceCardMetaDataPipe implements PipeTransform {
  transform(item: Document, widgetMetaValue, displayedColumns: string[]): string[] {
    const dsmetaDataValue = item.metadata;
    const widgetMetaDataValue = this.getWidgetValue(
      widgetMetaValue.widgetPayload.columnDisplayLabels,
      displayedColumns
    );
    const commonMetaData = [];
    const dsKeys = new Set(Object.keys(dsmetaDataValue));
    const widgetKeys = new Set(Object.keys(widgetMetaDataValue));
    for (const key of widgetKeys) {
      if (dsKeys.has(key)) {
        commonMetaData.push(`${widgetMetaDataValue[key]}: ${dsmetaDataValue[key]}`); // Indicate missing key
      }
    }
    return commonMetaData;
  }

  getWidgetValue(widgetMetaValue, displayedColumns: string[]): object {
    const metaData: any = {};
    for (const key in widgetMetaValue) {
      if (
        Object.prototype.hasOwnProperty.call(widgetMetaValue, key) &&
        displayedColumns.includes(key)
      ) {
        const newKey = key.replace('metadata.', '');
        metaData[newKey] = widgetMetaValue[key];
      }
    }
    return metaData;
  }
}
